// extracted by mini-css-extract-plugin
module.exports = {"SubsCarusel":"SubsCarusel_SubsCarusel__PWc_e","userName":"SubsCarusel_userName__Pdc55"};